import { api } from '../api'

/**
 * Schedulers data layer
 *
 * Provides methods to read and manipulate schedulers data
 * Depends on an API module that provides HTTP methods
 */
const JobSchedulerAPI = () => {
    return {
        getSchedulers,
        createScheduler,
        updateScheduler,
        deleteScheduler,
    }

    /**
     *
     * @returns
     */
    async function getSchedulers() {
        const scheduler = await api.get(`/api/automation/schedulers`)

        return scheduler
    }

    /**
     * Create a new scheduler
     * @param {object} schedulerDetails collected details of the scheduler
     * @returns success or error details
     */
    async function createScheduler(schedulerDetails) {
        const url = "/api/automation/schedulers"
        const data = compileFormData(schedulerDetails)
        // submit form data
        return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Edit a scheduler
     * @param {object} schedulerDetails collected details of the scheduler
     * @returns success or error details
     */
    async function updateScheduler(schedulerDetails, id) {
        const url = "/api/automation/schedulers/" + id
        const data = compileFormData(schedulerDetails)
        // submit form data 
        return await api.put(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Delete a Scheduler
     * @param {object} schedulerDetails collected details of the scheduler
     * @returns success or error details
     */
    async function deleteScheduler(id) {
        const response = await api.delete(`/api/automation/schedulers/${id}`)

        return response
    }

}

const compileFormData = (schedulerDetails) => {
    const { day, tool, concurrency_factor } = schedulerDetails

    const data = new FormData()
    data.append("day", day)
    data.append("tool", tool)
    data.append("concurrency_factor", concurrency_factor)

    return data
}

export default JobSchedulerAPI
